import type { ReactNode } from 'react';

export const symbol_format_text_overflow: ReactNode = (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 -960 960 960">
		<path
			fill="currentColor"
			d="M168.63-168.5Q160-177 160-190v-580q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v580q0 12-8.62 21-8.63 9-21.38 9-12.75 0-21.37-8.5ZM508.5-618.63Q500-627.25 500-640v-130q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v130q0 12-8.68 21-8.67 9-21.5 9-12.82 0-21.32-8.63ZM694-374q-9.07 9-21.53 9-12.47 0-21.47-9-9-9-9-21t9-21l34-34H350q-12 0-21-8.63-9-8.62-9-21.37 0-12.75 8.5-21.38Q337-510 350-510h335l-34-34q-9-9-9-21t9.05-21q9.06-9 21.5-9 12.45 0 21.45 9l85 85q9 9 9 21t-9 21l-85 85ZM508.63-168.5Q500-177 500-190v-130q0-12.75 8.68-21.38 8.67-8.62 21.5-8.62 12.82 0 21.32 8.62 8.5 8.63 8.5 21.38v130q0 12-8.62 21-8.63 9-21.38 9-12.75 0-21.37-8.5Z"
		/>
	</svg>
);
